import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-petition-approval',
  templateUrl: './petition-approval.component.html',
  styleUrls: ['./petition-approval.component.css']
})
export class PetitionApprovalComponent implements OnInit {

  title = "Petition Approval"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/petition/petition-approval/petition-approval.component.ts